import './GoLocation.scss';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { setGoLocation } from '../../../../../features/sharedSlice';
import { useDispatch } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import Point from 'ol/geom/Point';
import { setFitGeom } from '../../../../../features/mapSlice';

export default function GoLocation() {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [coordinateValue, setCoordinateValue] = useState<string>('');

    const toast = useRef<any>(null);

    const onInputCoordinate = (e: any) => {
        setCoordinateValue(e.target.value);
    };

    const onGoToLocation = () => {
        const replacedCoordinateValue = coordinateValue.replace(/ /g, '');
        
        const coordinateStringArray = replacedCoordinateValue.split(',');

        const coordinateNumberArray = coordinateStringArray.map((coordinateString) => Number(coordinateString));
        
        const point = new Point(coordinateNumberArray);
        
        const coords = point.getCoordinates();
        let isNotANumber = false;
        
        coords.forEach((coord:any)=>{
           if(isNaN(coord)){
            isNotANumber=true;
           }
        })
        if(!isNotANumber && coords.length === 2){
            // @ts-ignore
            dispatch(setFitGeom({ type: point.getType(), coordinates: point.getCoordinates() }));
        }
    };

    return (
        <>
            <Dialog
                header={t('COORDINATE COMP.Location')}
                visible={true}
                modal={false}
                onHide={() => {
                    dispatch(setGoLocation(false));
                }}
            >
                <div>
                    <InputText 
                        placeholder="43.26,26.43"
                        onInput={(e) => onInputCoordinate(e)}
                        onKeyDown={(e: any) => {
                            // console.log("e : ",e);
                            // console.log("e keyCode: ",e.keyCode);
                            if((e.keyCode>=65 && e.keyCode<=90) || e.keyCode===106 || e.keyCode===107 || e.keyCode===109 || e.keyCode===111){
                                e.preventDefault()
                            }
                        }}
                    />


                    <Button style={{ marginLeft: '25px' }} onClick={(e) => onGoToLocation()}>
                        {t('COORDINATE COMP.Go')}
                    </Button>
                </div>
            </Dialog>
            <Toast ref={toast} />
        </>
    );
}
